import React, { useState } from "react";

import SkillTile from "./skillTile";

export default ({
  sectionName,
  heading,
  phoneNumber,
  address,
  emailContactMethods
}) => {
  const [submitted, toggleSubmitted] = useState(false);

  return (
    <section
      className="colorlib-contact"
      data-section={sectionName.replace(/[^a-zA-Z0-9]/, "-")}
      id={sectionName.replace(/[^a-zA-Z0-9]/, "-")}
    >
      <div className="colorlib-narrow-content">
        <div className="row">
          <div className="col-md-6 col-md-offset-3 col-md-pull-3">
            <span className="heading-meta">{sectionName}</span>
            <h2 className="colorlib-heading">{heading}</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-md-5">
            {emailContactMethods && emailContactMethods.length ? (
              <div className="colorlib-feature colorlib-feature-sm">
                <div className="colorlib-icon">
                  <i className="icon-globe-outline" />
                </div>
                <div className="colorlib-text">
                  {
                    <p>
                      {emailContactMethods.map(({ email, title }) => (
                        <p style={{ marginBottom: "5px" }}>
                          <span style={{ marginRight: "5px" }}>{title}</span>
                          <br />
                          <a href={`mailto:${email}`}>{email}</a>
                          <br />
                        </p>
                      ))}
                    </p>
                  }
                </div>
              </div>
            ) : (
              ""
            )}
            {address ? (
              <div className="colorlib-feature colorlib-feature-sm">
                <div className="colorlib-icon">
                  <i className="icon-map" />
                </div>
                <div className="colorlib-text">
                  <p>{address}</p>
                </div>
              </div>
            ) : (
              ""
            )}
            {phoneNumber ? (
              <div className="colorlib-feature colorlib-feature-sm">
                <div className="colorlib-icon">
                  <i className="icon-phone" />
                </div>
                <div className="colorlib-text">
                  <p>
                    <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
                  </p>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="col-md-7 col-md-push-1">
            <div className="row">
              <div className="col-md-10 col-md-offset-1 col-md-pull-1">
                <form netlify data-netlify="true">
                  {(!submitted && (
                    <div className="form-group">
                      <input
                        className="form-control"
                        placeholder="Your name"
                        type="text"
                        name="name"
                        id="name"
                      />
                    </div>
                  )) ||
                    ""}
                  {(!submitted && (
                    <div className="form-group">
                      <input
                        className="form-control"
                        placeholder="Your email"
                        type="email"
                        name="email"
                        id="email"
                      />
                    </div>
                  )) ||
                    ""}
                  {(!submitted && (
                    <div className="form-group">
                      <textarea
                        className="form-control"
                        cols="30"
                        id="message"
                        name="message"
                        placeholder="Message"
                        rows="7"
                      />
                    </div>
                  )) ||
                    ""}
                  <div className="form-group">
                    {submitted ? (
                      <p style={{ textAlign: "center" }}>
                        <i className="icon-tick" /> Your message was sent
                        successfully
                      </p>
                    ) : (
                      <button
                        className="btn btn-primary btn-send-message"
                        onClick={() => {
                          try {
                            const iframe = document.createElement("iframe");
                            const name = document.getElementById("name").value;
                            const email = document.getElementById("email")
                              .value;
                            const message = document.getElementById("message")
                              .value;

                            iframe.style.display = "none";
                            iframe.src = `/form.html?name=${encodeURIComponent(
                              name
                            )}&email=${encodeURIComponent(
                              email
                            )}&message=${encodeURIComponent(message)}`;
                            document.body.appendChild(iframe);

                            toggleSubmitted(true);
                          } catch (e) {}
                        }}
                      >
                        Send Message
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/components/contactForm.js